import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
export default /*#__PURE__*/ _defineComponent({
    __name: 'video-btn-group',
    setup(__props) {
        /**
         * 单屏、四屏、全屏切换
         */
        const store = useMonitoringStore();
        const singleScreen = computed(() => store.singleScreen);
        const fullscreen = computed(() => store.fullScreen);
        const escfullScreenStatus = computed(() => store.escfullScreenStatus);
        const changeSingleScreen = (status) => {
            store.toggleSingleScreen(status);
        };
        const toggleFullScreen = () => {
            store.toggleFullScreen(!fullscreen.value);
        };
        return { __sfc: true, store, singleScreen, fullscreen, escfullScreenStatus, changeSingleScreen, toggleFullScreen };
    }
});
